import { Spinner } from '@/components/ui';

/** Full-viewport wait: session hydrate and /me. Matches the login wash so
 *  sign-in → workspace does not flash a blank white column. */
export function SessionLoader() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-6"
      data-testid="session-loader"
      aria-busy="true"
      aria-live="polite"
    >
      <img src="/logo.svg" alt="" className="w-12 h-12 mb-5" />
      <Spinner size="md" />
      <p className="mt-4 text-sm text-gray-500">Loading your workspace</p>
    </div>
  );
}

/** In-pane wait: lazy route chunks. Sidebar and top bar stay mounted. */
export function PageLoader() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center" data-testid="page-loader">
      <Spinner size="md" />
    </div>
  );
}
